import { render, staticRenderFns } from "./pwd.vue?vue&type=template&id=5475419e&scoped=true"
import script from "./pwd.vue?vue&type=script&lang=js"
export * from "./pwd.vue?vue&type=script&lang=js"
import style0 from "./pwd.vue?vue&type=style&index=0&id=5475419e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475419e",
  null
  
)

export default component.exports